import PropTypes from 'prop-types'
import React from 'react'

import ErrorMessage from '@/components/error-message/ErrorMessage.jsx'
import StatusInputIcon from '@/components/input/status-input/StatusInput.jsx'
import {
    StyledIcon,
    StyledInput,
    StyledInputWrapper,
    StyledLabel,
    StyledContainer,
} from '@/components/input/styles.js'

const Input = React.forwardRef(
    (
        {
            label,
            name,
            type = 'text',
            placeholder,
            onChange,
            onBlur,
            icon,
            iconPosition = 'left',
            iconCallback,
            statusIcon,
            statusIconCallback,
            touched = false,
            required = false,
            errors,
            helpText,
            className,
            inputProps,
            disabled,
            size = 'small',
            width = '174px',
            variant = 'transparent',
            ...rest
        },
        ref
    ) => {
        return (
            <StyledContainer size={size} width={width} className={className}>
                {label && (
                    <StyledLabel disabled={disabled} htmlFor={name}>
                        {label}
                        {required && '*'}
                    </StyledLabel>
                )}
                <StyledInputWrapper
                    iconPosition={iconPosition}
                    touched={touched}
                    hasError={!!errors}
                    isSuccess={!errors && touched}
                    disabled={disabled}
                    size={size}
                    variant={variant}
                >
                    {icon && (
                        <StyledIcon disabled={disabled} onClick={iconCallback}>
                            {icon}
                        </StyledIcon>
                    )}
                    <StyledInput
                        ref={ref}
                        type={type}
                        name={name}
                        placeholder={placeholder}
                        onChange={onChange}
                        onBlur={onBlur}
                        disabled={disabled}
                        variant={variant}
                        {...inputProps}
                        {...rest}
                        autoComplete="off"
                        onWheel={event => {
                            if (event.target.type === 'number') {
                                event.target.value =
                                    +event.target.value +
                                    Math.sign(event.deltaY)
                            }
                        }}
                    />
                    {/*icon status*/}
                    <StatusInputIcon
                        statusIcon={statusIcon}
                        statusIconCallback={statusIconCallback}
                        touched={touched}
                        errors={errors}
                    />
                </StyledInputWrapper>

                {/*help text*/}
                <ErrorMessage errors={errors} helpText={helpText} />
            </StyledContainer>
        )
    }
)

export default Input

Input.propTypes = {
    label: PropTypes.string,
    name: PropTypes.string,
    type: PropTypes.string,
    placeholder: PropTypes.string,
    onChange: PropTypes.func,
    onBlur: PropTypes.func,
    icon: PropTypes.node,
    iconPosition: PropTypes.oneOf(['left', 'right']),
    iconCallback: PropTypes.func,
    statusIcon: PropTypes.node,
    statusIconCallback: PropTypes.func,
    touched: PropTypes.bool,
    required: PropTypes.bool,
    errors: PropTypes.object,
    helpText: PropTypes.string,
    className: PropTypes.string,
    inputProps: PropTypes.object,
    disabled: PropTypes.bool,
    size: PropTypes.oneOf(['small', 'medium', 'large']),
    width: PropTypes.string,
    variant: PropTypes.oneOf(['transparent', 'filled']),
}

Input.displayName = 'Input'
